
import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Pencil, Trash2 } from "lucide-react";
import { KeyAsk } from "../types";

interface KeyRequestsTableProps {
  keyAsks: KeyAsk[];
  isLoading: boolean;
  onEdit: (ask: KeyAsk) => void;
  onDelete: (id: string) => void;
  canEdit: boolean;
}

export const KeyRequestsTable = ({ keyAsks, isLoading, onEdit, onDelete, canEdit }: KeyRequestsTableProps) => {
  const calculateEmptyRows = () => {
    const minVisibleRows = 8;
    const currentRows = keyAsks.length;
    const emptyRowsNeeded = Math.max(minVisibleRows - currentRows, 0);
    return Array.from({ length: emptyRowsNeeded }, (_, i) => i);
  };

  if (isLoading) {
    return <div className="text-center py-4 text-white">Loading...</div>;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow className="bg-primary/30 hover:bg-primary/30">
          <TableHead className="text-primary-light text-[11px]">SN</TableHead>
          <TableHead className="text-primary-light text-[11px]">Requestor</TableHead>
          <TableHead className="text-primary-light text-[11px]">Description</TableHead>
          <TableHead className="text-primary-light text-[11px]">Action By</TableHead>
          <TableHead className="text-primary-light text-[11px]">Approver</TableHead>
          <TableHead className="text-primary-light text-[11px]">Expected Date</TableHead>
          <TableHead className="text-primary-light text-[11px]">Status</TableHead>
          <TableHead className="text-primary-light text-[11px]">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {keyAsks.map((ask, index) => (
          <TableRow key={ask.id} className="bg-secondary-light/5">
            <TableCell className="text-white text-[11px]">{index + 1}</TableCell>
            <TableCell className="text-white text-[11px]">{ask.requestor_name}</TableCell>
            <TableCell className="text-white text-[11px]">{ask.request_description}</TableCell>
            <TableCell className="text-white text-[11px]">{ask.action_by}</TableCell>
            <TableCell className="text-white text-[11px]">{ask.approver}</TableCell>
            <TableCell className="text-white text-[11px]">
              {ask.expected_completion_date ? new Date(ask.expected_completion_date).toLocaleDateString() : ''}
            </TableCell>
            <TableCell className="text-white text-[11px]">{ask.status}</TableCell>
            <TableCell className="text-white text-[11px]">
              <div className="flex gap-2">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onEdit(ask)}
                  className="h-8 w-8 text-primary hover:text-white hover:bg-primary"
                  disabled={!canEdit}
                >
                  <Pencil className="h-4 w-4" />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onDelete(ask.id)}
                  className="h-8 w-8 text-primary hover:text-white hover:bg-primary"
                  disabled={!canEdit}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
        {calculateEmptyRows().map(index => (
          <TableRow key={`empty-${index}`} className="bg-secondary-light/5">
            <TableCell className="text-white text-[11px]">&nbsp;</TableCell>
            <TableCell className="text-white text-[11px]">&nbsp;</TableCell>
            <TableCell className="text-white text-[11px]">&nbsp;</TableCell>
            <TableCell className="text-white text-[11px]">&nbsp;</TableCell>
            <TableCell className="text-white text-[11px]">&nbsp;</TableCell>
            <TableCell className="text-white text-[11px]">&nbsp;</TableCell>
            <TableCell className="text-white text-[11px]">&nbsp;</TableCell>
            <TableCell className="text-white text-[11px]">&nbsp;</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
